import { Conn_Obj_Property } from '../models/datapoint/connObjProperty';

export class Conn_Obj_PropertiesUtil {
    private static instance: Conn_Obj_PropertiesUtil;

    static getInstance(): Conn_Obj_PropertiesUtil {
        if (!Conn_Obj_PropertiesUtil.instance) {
            Conn_Obj_PropertiesUtil.instance = new Conn_Obj_PropertiesUtil();
        }

        return Conn_Obj_PropertiesUtil.instance;
    }

    /**
    * Conn_Obj_PropertiesUtil is a singleton class, so use Conn_Obj_PropertiesUtil.getInstance() method instead of creating new Conn_Obj_PropertiesUtil().
    */
    private constructor() {
        
    }

    copyFrom(conn_Obj_Properties: Array<Conn_Obj_Property>, conn_Obj_PropertiesCopy: Array<Conn_Obj_Property>): void {

    }

    compare(conn_Obj_Properties: Array<Conn_Obj_Property>, conn_Obj_PropertiesCopy: Array<Conn_Obj_Property>): string {

        let conn_Obj_PropertiesLength = conn_Obj_Properties.length;
        let conn_Obj_PropertiesCopyLength = conn_Obj_PropertiesCopy.length;

        if (conn_Obj_PropertiesLength != conn_Obj_PropertiesCopyLength) {
            return 'Conn_Obj_Properties length is different.';
        }

        let conn_Obj_PropertiesCopyMap: Map<number, Conn_Obj_Property> = new Map();
        for (let i: number = 0; i < conn_Obj_PropertiesCopyLength; i++) {
            let conn_Obj_PropertyCopy: Conn_Obj_Property = conn_Obj_PropertiesCopy[i] as Conn_Obj_Property;
            conn_Obj_PropertiesCopyMap.set(conn_Obj_PropertyCopy.conn_Id, conn_Obj_PropertyCopy);
        }

        for (let i: number = 0; i < conn_Obj_PropertiesLength; i++) {
            let conn_Obj_Property: Conn_Obj_Property = conn_Obj_Properties[i] as Conn_Obj_Property;

            let conn_Obj_PropertyCopy: Conn_Obj_Property = conn_Obj_PropertiesCopyMap.get(conn_Obj_Property.conn_Id);
            if (!conn_Obj_PropertyCopy) {
                return conn_Obj_Property.conn_Id + ' Conn_Obj_Property is found in copy.'
            }

            if (conn_Obj_Property.compare(conn_Obj_PropertyCopy) != '') {
                return conn_Obj_Property.conn_Id + ' Conn_Obj_Property is not equal.'
            }
        }

        return '';
    }
}